<template>
  <b-container>
    <b-card>
      <b-row>
        <b-col>
          <p class="font-weight-bolder">Informasi Detail</p>
        </b-col>
        <b-col class="text-right">
          <b-badge :variant="statusVariant(this.form.status)" class="mb-1">
            <span v-if="this.form.status === 0">Non Aktif</span>
            <span v-else-if="this.form.status === 1">Aktif</span>
          </b-badge>
        </b-col>
      </b-row>
      <b-form v-on:submit.prevent>
        <b-row>
          <b-col md="12">
            <b-form-group label="Nama" label-for="name">
              <b-form-input
                id="name"
                placeholder="Nama"
                v-model="form.name"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Deskripsi" label-for="description">
              <b-form-textarea
                id="description"
                placeholder="Deskripsi"
                v-model="form.description"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col md="12">
            <b-form-group label="Alamat" label-for="address">
              <b-form-textarea
                id="address"
                placeholder="Alamat"
                v-model="address.address"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Kelurahan" label-for="village">
              <b-form-input
                id="village"
                placeholder="Kelurahan"
                v-model="address.village"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Kecamatan" label-for="district">
              <b-form-input
                id="district"
                placeholder="Kecamatan"
                v-model="address.district"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Kota" label-for="city">
              <b-form-input
                id="city"
                placeholder="Kota"
                v-model="address.city"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Provinsi" label-for="province">
              <b-form-input
                id="province"
                placeholder="Provinsi"
                v-model="address.province"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Negara" label-for="country">
              <b-form-input
                id="country"
                placeholder="Negara"
                v-model="address.country"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Kode Pos" label-for="postal_code">
              <b-form-input
                id="postal_code"
                placeholder="Kode Pos"
                v-model="address.postal_code"
                type="number"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
    <b-card>
      <b-row class="mb-1">
        <b-col md="4">
          <b-form-group label="Latitude" label-for="latitude">
            <b-form-input
              id="latitude"
              placeholder="Latitude"
              v-model="address.latitude"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Longitude" label-for="longitude">
            <b-form-input
              id="longitude"
              placeholder="Longitude"
              v-model="address.longitude"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="Cari"
            variant="primary"
            @click="updateLocation()"
            class="mt-2"
          >
            cari
          </b-button>
        </b-col>
      </b-row>
      <GmapMap :center="center" :zoom="17" style="width: 100%; height: 400px">
        <GmapMarker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :clickable="true"
          :draggable="true"
          @click="center = m.position"
          @dragend="updateCoordinates"
        />
      </GmapMap>
    </b-card>
    <b-row>
      <!-- submit and reset -->
      <b-col md="6">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="success"
          @click="update()"
          block
        >
          Simpan
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="danger"
          @click="destroy()"
          block
        >
          Hapus
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BFormTextarea,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BBadge,
  BContainer,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { $themeConfig } from "@themeConfig";

export default {
  components: {
    ToastificationContent,
    BFormTextarea,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
    BBadge,
    BContainer,
  },
  directives: {
    Ripple,
  },
  computed: {
    statusVariant() {
      const statusColor = {
        0: "light-warning",
        1: "light-success",
      };

      return (status) => statusColor[status];
    },
  },
  mounted() {},
  data() {
    return {
      form: {
        name: "",
        description: "",
      },
      address: {
        address: "",
        village: "",
        district: "",
        city: "",
        province: "",
        country: "",
        postal_code: "",
        latitude: null,
        longitude: null,
      },
      center: { lat: -6.1751150688690535, lng: 106.8271742576702 },
      currentPlace: null,
      markers: [],
      places: [],
      permissions: [],
      errors: "",
      errMessage: "",
    };
  },
  created() {
    this.getAllPermissions();
    this.getDetails();
  },
  methods: {
    getAllPermissions() {
      this.permissions = sessionStorage.getItem("permissions");
    },
    getDetails() {
      const id = this.$route.params.id;
      this.$http.get("place/charging-station/" + id).then((response) => {
        let $data = response.data.data;

        this.form.name = $data.name;
        this.form.description = $data.description;
        this.address.address = $data.address;
        this.address.village = $data.village;
        this.address.district = $data.district;
        this.address.city = $data.city;
        this.address.province = $data.province;
        this.address.country = $data.country;
        this.address.postal_code = $data.postal_code;
        this.address.latitude = $data.latitude;
        this.address.longitude = $data.longitude;
        this.center.lat = $data.latitude;
        this.center.lng = $data.longitude;

        this.markers.push({
          position: {
            lat: $data.latitude,
            lng: $data.longitude,
          },
        });
      });
    },
    update() {
      if (this.form.name === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notifikasi",
            icon: "BellIcon",
            text: "Nama tidak boleh kosong",
            variant: "warning",
          },
        });
      } else {
        const id = this.$route.params.id;
        this.$http
          .post("place/charging-station/" + id + "/update", {
            name: this.form.name,
            desciprtion: this.form.desciprtion,
            address: this.address.address,
            village: this.address.village,
            district: this.address.district,
            city: this.address.city,
            province: this.address.province,
            country: this.address.country,
            postal_code: this.address.postal_code,
            latitude: this.address.latitude,
            longitude: this.address.longitude,
          })
          .then((response) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Notifikasi",
                icon: "BellIcon",
                text: "Data berhasil diperbaharui",
                variant: "success",
              },
            });
            location.href = "/place/charging-stations";
            // console.log(response.data.data)
          })
          .catch((errors) => {
            this.errMessage = errors.response.data.message;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Notifikasi",
                icon: "BellIcon",
                text: this.errMessage,
                variant: "warning",
              },
            });
            console.log(errors.response);
          });
      }
    },
    destroy() {
      const id = this.$route.params.id;
      this.$http
        .post("place/charging-station/" + id + "/delete")
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notifikasi",
              icon: "BellIcon",
              text: "Data berhasil dihapus",
              variant: "danger",
            },
          });
          location.href = "/place/charging-stations";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          console.log(errors.response);
        });
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: this.address.latitude,
          lng: this.address.longitude,
        };
      });
    },
    updateCoordinates(location) {
      this.address.latitude = location.latLng.lat();
      this.address.longitude = location.latLng.lng();
    },
    updateLocation() {
      this.markers = [];
      this.center = {
        lat: parseFloat(this.address.latitude),
        lng: parseFloat(this.address.longitude),
      };
      this.markers.push({
        position: {
          lat: parseFloat(this.address.latitude),
          lng: parseFloat(this.address.longitude),
        },
      });
    },
  },
};
</script>

<style>
#customercategory option:disabled {
  font-weight: bolder;
  /* color: darkgray; */
  /* text-align: center; */
  background-color: #ebebeb;
}
#customercategory option:not([disabled]) {
  margin-left: 40px !important;
  transform: scaleX(200px);
}
</style>